// extracted by mini-css-extract-plugin
export default {"forgotPasswordContainer":"pORC0eT5jSUHW3y0_W0A"};